import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrderCenterHistoryList } from '@/services'
import { Accordion, Text } from '@mercai/clever'

// import { HistoryTimeline } from './components'
import { groupHistoryByDay } from './tab-history.constants'

import { TabHistoryProps } from './tab-history.type'

import { HistoryTimeline } from '@/components'
import { formatLongDate } from '@/helpers'
import styles from './tab-history.module.css'

export const TabHistory = ({ saleOrderUuid }: TabHistoryProps) => {
  const { t } = useTranslation('screenOrderCenterPage')

  const [activeItems, setActiveItems] = useState<string[]>([])

  const { data, isLoading } = useOrderCenterHistoryList(saleOrderUuid)

  const formattedData = useMemo(
    () => groupHistoryByDay(data?.data?.timeline),
    [data?.data?.timeline],
  )

  useEffect(() => {
    setActiveItems(formattedData?.map((_, i) => `history-${i}`) || [])
  }, [formattedData])

  return (
    <div className={styles.container}>
      <Text variant="title-medium">
        {t('orderCenterShowTabHistoryTitle', {
          value: data?.data?.timeline?.length || 0,
        })}
      </Text>
      {!isLoading &&
      data?.data?.timeline &&
      data?.data?.timeline?.length > 0 ? (
        <div>
          <Accordion.Root
            activeItems={activeItems}
            onHandleActiveItems={setActiveItems}
          >
            {formattedData.map((items, index) => (
              <Accordion.Item
                key={index}
                id={`history-${index}`}
                header={
                  <Text className={styles.header} variant="text-small">
                    {formatLongDate(items?.[0]?.createdAt)}
                  </Text>
                }
                className={styles.item}
              >
                <div className={styles.content}>
                  <HistoryTimeline
                    items={items}
                    translationKey="saleOrderHistoryEnums"
                    coreEntity="sale_order"
                  />
                </div>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </div>
      ) : (
        <Text variant="text-base">{t('orderCenterShowTabHistoryEmpty')}</Text>
      )}
    </div>
  )
}
